<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>


    <!-- FORM HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- FORM TITLE -->
                <div class="col-6">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-x-octagon me-2 fs-1 text-primary"></i>Penalización
                    </h4>
                </div>

                <div class="col-6 align-items-lg-end">
                    <div class="row">
                        <!-- FUNCTIONS BUTTONS -->
                        <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                            <div *ngIf="opE === '1' && mostrarBtnPenalizacion === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                                    <i class="bi-pencil-square me-2"></i>Editar
                                </button>
                            </div>

                            <div *ngIf="opE === '1' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary f-6" data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                                    <i class="bi bi-chat-left-text me-2"></i>Comentario
                                </button>
                            </div>

                            <div *ngIf="opE === '1' && mostrarBtnVoBo === false && penalizacion.DepPen_VoBo !== 'VoBo' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="cambioEstatus()" class="INN-function-button link-opacity-50-hover text-decoration-none link-success fs-6">
                                    <i class="bi bi-person-check-fill me-2 "></i>VoBo
                                </button>
                            </div>

                            <div *ngIf=" opE === '1' && mostrarBtnPenalizacion === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                                    <i class="bi-trash3 me-2"></i>Eliminar
                                </button>
                            </div>

                            <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                                    <i class="bi-save me-2"></i>Guardar
                                </button>
                            </div>

                            <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                                <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                                    <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- FORM CONTENT -->
    <div class="container pe-6">
        <div class="card card-body INN-form justify-content-center mt-2">
            <form class="needs-validation" novalidate>
                <div class="row g-3">

                    <div class="collapse multi-collapse" id="multiCollapseExample1">
                        <!-- TEXT AREA -->
                        <div class="col-md-12">
                            <label for="formControlTextarea1" class="form-label">Comentarios</label>
                            <textarea class="form-control" name="penalizacion.DepPen_Observaciones" id="penalizacion.DepPen_Observaciones" [(ngModel)]="penalizacion.DepPen_Observaciones" rows="2" [disabled]="esAdministrador()"></textarea>
                        </div>
                        <br>
                        <button *ngIf="rol === 'Administrador' && penalizacion.DepPen_VoBo !== 'Aclaracion' " (click)="comentarios()" type="button" class="col-3 btn btn-outline-secondary INN-color-white-hover">
                            <i class="bi bi-chat-left-text me-2"></i>Enviar comentarios
                        </button>
                    </div>

                    <div>
                        <p class="small text-primary" *ngIf="validacionRol !== 'Otro rol' && opE === '1' ">
                            <i class="bi bi-person-circle me-2"> </i> {{validacionRol}} 
                        </p>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-7">
                        <label for="Field" class="form-label">Proyecto</label>
                        <select class="form-select" name="penalizacion.FKId_Proyecto" id="penalizacion.FKId_Proyecto" [(ngModel)]="penalizacion.FKId_Proyecto" #FKId_Proyecto="ngModel" [ngClass]="{'is-invalid': FKId_Proyecto.invalid && (FKId_Proyecto.dirty || FKId_Proyecto.touched)}"
                            (ngModelChange)="mostrarMensaje(FKId_Proyecto, 'proyecto')" (blur)="mostrarMensaje(FKId_Proyecto, 'proyecto')" required [disabled]="validacionCampos === false ">
                            <option value=0>Seleccione el proyecto...</option>
                            <ng-container *ngFor="let proyecto of proyectos">
                                <option *ngIf="proyecto.Pry_Estatus === 'Activo' && proyecto.Pry_Activo" [value]="proyecto.Id_Proyecto">{{
                                    proyecto.Pry_Clave }}</option>
                            </ng-container>
                        </select>
                        <p class="invalid-feedback" [ngStyle]="{ display: showErrorMessageProy ? 'block' : 'none' }" *ngIf="showErrorMessageProy">
                            {{mensajeValidacionProy}}
                        </p>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-5">
                        <label for="Field" class="form-label">Área que factura</label>
                        <select class="form-select" name="penalizacion" id="penalizacion" [(ngModel)]="penalizacion.FKId_Direccion" #areaFactura="ngModel" [ngClass]="{'is-invalid': areaFactura.invalid && (areaFactura.dirty || areaFactura.touched)}" (ngModelChange)="mostrarMensaje(areaFactura, 'factura')"
                            (blur)="mostrarMensaje(areaFactura, 'factura')" required [disabled]="validacionCampos === false ">
                            <option value=0>Seleccione el área a facturar...</option>
                            <ng-container *ngFor="let area of areas">
                                <option *ngIf="area.Dir_Activo" [value]="area.Id_Direccion">{{ area.Dir_Nombre }}
                                </option>
                            </ng-container>
                        </select>
                        <p class="invalid-feedback" [ngStyle]="{ display: showErrorMessageFac ? 'block' : 'none' }" *ngIf="showErrorMessageFac">
                            {{mensajeValidacionFac}}
                        </p>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-4">
                        <label for="menuField" class="form-label">Mes de servicio</label>
                        <select class="form-select" name="penalizacion.DedPen_Mes" [(ngModel)]="penalizacion.DedPen_Mes" #mes="ngModel" [ngClass]="{'is-invalid': mes.invalid && (mes.dirty || mes.touched)}" (ngModelChange)="mostrarMensaje(mes, 'mes')" (blur)="mostrarMensaje(mes, 'mes')"
                            required [disabled]="validacionCampos === false ">
                            <option value="">Seleccione mes de servicio...</option>
                            <option *ngFor="let mes of meses" [value]="mes">{{ mes }}</option>
                        </select>
                        <p class="invalid-feedback" *ngIf="showErrorMessageMes">
                            {{mensajeValidacionMes}}
                        </p>
                    </div>

                    <div class="col-md-4">
                        <label for="Field" class="form-label">Año de servicio</label>
                        <div class="input-group">

                            <select class="form-select" name="deductiva.DedPen_Ano"
                            [(ngModel)]="penalizacion.DedPen_Ano"
                            #DedPen_Ano="ngModel"
                            [ngClass]="{
                              'is-invalid': DedPen_Ano.invalid && (DedPen_Ano.dirty || DedPen_Ano.touched)
                            }"
                            (ngModelChange)="mostrarMensaje(DedPen_Ano, 'anio')"
                            (blur)="mostrarMensaje(DedPen_Ano, 'anio')"
                            required [disabled]="validacionCampos === false">
                                <option value="">Seleccione año de servicio...</option>
                                <option *ngFor="let anioItem of anios" [ngValue]="anioItem">
                                    {{ anioItem }}
                                </option>
                            </select>    

                            <p class="invalid-feedback" *ngIf="showErrorMessageAnio">
                                {{mensajeValidacionAnio}}
                            </p>
                        </div>
                    </div>

                    <!-- FIELD SYMBOL LEFT-->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Monto</label>
                        <div class="input-group">
                            <span class="input-group-text">$</span>
                            <input type="text" class="form-control" name="penalizacion.DedPen_Monto" [(ngModel)]="penalizacion.DedPen_Monto" #DedPen_Monto="ngModel" [ngClass]="{'is-invalid': DedPen_Monto.invalid && (DedPen_Monto.dirty || DedPen_Monto.touched)}" min="0" (ngModelChange)="mostrarMensaje(DedPen_Monto, 'monto')"
                                (blur)="mostrarMensaje(DedPen_Monto, 'monto')" (input)="filterInput($event)" required [disabled]="validacionCampos === false ">
                            <br>
                            <p *ngIf="showErrorMessageMonto === true" class="mensaje-error">
                                {{mensajeValidacionMonto}}
                            </p>
                        </div>
                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">

                    <!-- COMPONENT PREVIEW PDF -->
                    <app-viewpdf [pdfUrl]="pdfUrl" [modalVisible]="modalVisible" [namepdf]="namepdf" (modalClosed)="onModalClosed()" *ngIf="modalVisible"></app-viewpdf>

                    <!-- ATTACH FILE ARRANGE -->
                    <div class="row g-3 mt-0">
                        <!-- ATTACH FILE -->
                        <div class="col-md-12 col-lg-6">
                            <label for="formFile" class="form-label">Adjuntar documento de respaldo</label>
                            <div class="input-group mb-3">
                                <input type="file" name="selectedFile" id="selectedFile" class="form-control" [(ngModel)]="selectedFile" id="ficha-comparativa-de-compra" accept=".pdf" (change)="onFileSelected($event, 'DocumentosRespaldo')" 
                                [disabled]="
                                    validacionCampos === false ||
                                    penalizacion.FKId_Proyecto === 0 ||
                                    penalizacion.FKId_Direccion === 0 ||
                                    penalizacion.DedPen_Mes === '' ||
                                    penalizacion.DedPen_Ano === '' ||
                                    penalizacion.DedPen_Monto === 0">
                            </div>
                        </div>
                        <!-- SPACER -->
                        <div class="col-md-12 col-lg-6"></div>
                        <!-- FILE PDF -->
                        <div class="col-sm-12 col-md-6 col-lg-3" *ngFor="let opcional of myDocs; let i=index">
                            <div class="input-group mb-3">
                                <div title="Ver">
                                    <button type="button" 
                                    class="btn btn-outline-danger INN-color-white-hover btn-pdf" 
                                    (click)="openModal(opcional)"
                                    >
                                        <i class="bi bi-file-earmark-pdf-fill"></i>
                                    </button>
                                </div>
                                <input type="text" class="form-control" placeholder="{{opcional.DedPenDoc_Nombre}}" disabled aria-label="Username" aria-describedby="basic-addon1">
                                <div title="Descargar">
                                    <button class="btn btn-outline-primary INN-color-white-hover rounded-0" type="button" id="basic-addon1" (click)="downloadDocument(opcional)">
                                        <i class="bi bi-download  px-1"></i>
                                    </button>
                                </div>

                                <div title="Eliminar Documento(Si se elimina no se podra recuperar)" [ngClass]="{'disabled-section': penalizacion.DepPen_VoBo === 'VoBo' && rol !== 'Administrador'}">
                                    <button class="btn btn-outline-danger btn-delete" type="button" id="basic-addon1" (click)="deleteFile(i,opcional,'DocumentosRespaldo')" [disabled]="validacionCampos === false">
                                        <i class="bi bi-trash px-1"></i>
                                    </button>
                                </div>

                            </div>
                        </div>



                    </div>
                    <!-- END ATTACH FILE ARRANGE -->

                </div>
            </form>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2 mb-4">
            <div class="row">

                <!-- FORM FOOTER CONTENT -->
                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                    <div *ngIf="opE === '1' && mostrarBtnPenalizacion === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-pencil-square me-2"></i>Editar
                        </button>
                    </div>

                    <div *ngIf="opE === '1' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary f-6" data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                            <i class="bi bi-chat-left-text me-2"></i>Comentario
                        </button>
                    </div>

                    <div *ngIf="opE === '1' && mostrarBtnVoBo === false && penalizacion.DepPen_VoBo !== 'VoBo' " class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cambioEstatus()" class="INN-function-button link-opacity-50-hover text-decoration-none link-success fs-6">
                            <i class="bi bi-person-check-fill me-2 "></i>VoBo
                        </button>
                    </div>

                    <div *ngIf=" opE === '1' && mostrarBtnPenalizacion === false" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                            <i class="bi-trash3 me-2"></i>Eliminar
                        </button>
                    </div>

                    <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-save me-2"></i>Guardar
                        </button>
                    </div>

                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- FIXED SPACE FOR MAIN FOOTER-->
    <div class="container">
        <div class="row mb-4 pb-4">
        </div>
    </div>

</div>
<!-- END MAIN CONTAINER -->
